(function(){
  'use strict';

  /* ---------- Para formatı ---------- */
  function formatTL(cents){
    var v = (cents/100);
    return v.toLocaleString('tr-TR',{minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits:2}) + ' TL';
  }

  /* ---------- Galeri ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var track = g.querySelector('.gallery__slides');
    var thumbs = g.querySelectorAll('.gallery__thumb');
    if(!track) return;
    function go(i){
      var n = track.children.length; if(!n) return;
      i = (i+n)%n;
      track.scrollTo({left: track.clientWidth*i, behavior:'smooth'});
    }
    function current(){ return Math.round(track.scrollLeft / Math.max(track.clientWidth,1)); }
    thumbs.forEach(function(t,i){ t.addEventListener('click',function(){ go(i); }); });
    var prev = g.querySelector('.gallery__arrow--prev'), next = g.querySelector('.gallery__arrow--next');
    if(prev) prev.addEventListener('click',function(){ go(current()-1); });
    if(next) next.addEventListener('click',function(){ go(current()+1); });
    var raf;
    track.addEventListener('scroll',function(){
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function(){
        var c = current();
        thumbs.forEach(function(t,i){ t.classList.toggle('is-active', i===c); });
      });
    },{passive:true});
  });

  /* ---------- Paket seçimi ---------- */
  document.querySelectorAll('[data-bundle]').forEach(function(b){
    var form = document.getElementById(b.getAttribute('data-form'));
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var opts = b.querySelectorAll('.bundle__opt');
    function select(opt){
      opts.forEach(function(o){ o.classList.toggle('is-selected', o===opt); });
      var r = opt.querySelector('input'); if(r) r.checked = true;
      if(idInput && opt.dataset.variant) idInput.value = opt.dataset.variant;
      document.querySelectorAll('[data-sticky-price]').forEach(function(el){ el.textContent = opt.dataset.priceLabel || ''; });
      document.querySelectorAll('[data-sticky-name]').forEach(function(el){ el.textContent = opt.dataset.name || ''; });
    }
    opts.forEach(function(o){ o.addEventListener('click',function(){ select(o); }); });
    var pre = b.querySelector('.bundle__opt.is-selected') || opts[0];
    if(pre) select(pre);
  });

  /* ---------- 30 dakikalık sayaç (her periyotta yeniden başlar) ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var period = (parseInt(el.getAttribute('data-minutes'),10) || 30) * 60 * 1000;
    var mm = el.querySelector('[data-mm]'), ss = el.querySelector('[data-ss]');
    function pad(n){ return (n<10?'0':'')+n; }
    function tick(){
      var left = period - (Date.now() % period);
      var s = Math.floor(left/1000);
      mm.textContent = pad(Math.floor(s/60));
      ss.textContent = pad(s%60);
    }
    tick(); setInterval(tick,1000);
  });

  /* ---------- Teslimat tarihleri ---------- */
  function addBusinessDays(date, days, skipSat){
    var d = new Date(date);
    var added = 0;
    while(added < days){
      d.setDate(d.getDate()+1);
      var w = d.getDay();
      if(w===0) continue;
      if(skipSat && w===6) continue;
      added++;
    }
    return d;
  }
  var fmt = function(d){ return d.toLocaleDateString('tr-TR',{day:'numeric',month:'long'}); };
  document.querySelectorAll('[data-delivery]').forEach(function(el){
    var shipDays = parseInt(el.dataset.ship,10); if(isNaN(shipDays)) shipDays = 1;
    var minD = parseInt(el.dataset.min,10) || 3;
    var maxD = parseInt(el.dataset.max,10) || minD;
    var skipSat = el.dataset.skipSat === 'true';
    var now = new Date();
    var shipped = addBusinessDays(now, shipDays, skipSat);
    var dMin = addBusinessDays(shipped, minD, skipSat);
    var dMax = addBusinessDays(shipped, maxD, skipSat);
    var o = el.querySelector('[data-d-order]'), s = el.querySelector('[data-d-ship]'), t = el.querySelector('[data-d-arrive]');
    if(o) o.textContent = fmt(now);
    if(s) s.textContent = fmt(shipped);
    if(t) t.textContent = (minD===maxD) ? fmt(dMax) : (dMin.getMonth()===dMax.getMonth() ? dMin.getDate()+' - '+fmt(dMax) : fmt(dMin)+' - '+fmt(dMax));
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ el.classList.add('is-animated'); io.disconnect(); } });
    },{threshold:.4});
    io.observe(el);
  });

  /* ---------- Mobil sabit buton ---------- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var mainBtn = document.querySelector('[data-main-atc]');
  if(sticky && mainBtn){
    new IntersectionObserver(function(es){
      es.forEach(function(e){
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
      });
    }).observe(mainBtn);
    var go = sticky.querySelector('[data-sticky-go]');
    if(go) go.addEventListener('click',function(){
      var target = document.querySelector('[data-bundle]') || mainBtn;
      target.scrollIntoView({behavior:'smooth',block:'center'});
    });
  }

  /* ---------- Görünürlük animasyonu ---------- */
  var rev = document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window){
    var ro = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); ro.unobserve(e.target); } });
    },{threshold:.12});
    rev.forEach(function(r){ ro.observe(r); });
  } else rev.forEach(function(r){ r.classList.add('is-in'); });

  /* ---------- Sepet adet butonları ---------- */
  document.querySelectorAll('[data-qty]').forEach(function(q){
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function(btn){
      btn.addEventListener('click',function(){
        var v = parseInt(input.value,10)||0;
        input.value = Math.max(0, v + (btn.dataset.step==='+'?1:-1));
        input.form && input.form.submit();
      });
    });
  });

  /* ---------- Kampanya bandı geri sayımı (Türkiye saati) ---------- */
  document.querySelectorAll('[data-promo]').forEach(function(el){
    var raw = (el.getAttribute('data-end') || '').trim();
    var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/);
    if(!m) return;
    var end = Date.UTC(+m[1], +m[2]-1, +m[3], (m[4]?+m[4]:23) - 3, m[5]?+m[5]:59, 59);
    var d = el.querySelector('[data-p-d]'), h = el.querySelector('[data-p-h]'), mi = el.querySelector('[data-p-m]'), se = el.querySelector('[data-p-s]');
    function pad(n){ return (n<10?'0':'')+n; }
    function tick(){
      var left = end - Date.now();
      if(left <= 0){ el.hidden = true; return; }
      var s = Math.floor(left/1000);
      if(d) d.textContent = pad(Math.floor(s/86400));
      if(h) h.textContent = pad(Math.floor(s%86400/3600));
      if(mi) mi.textContent = pad(Math.floor(s%3600/60));
      if(se) se.textContent = pad(s%60);
    }
    tick(); setInterval(tick,1000);
  });

  /* ---------- Önce / Sonra slider ---------- */
  document.querySelectorAll('[data-ba]').forEach(function(el){
    var r = el.querySelector('[data-ba-range]');
    if(!r) return;
    function set(){ el.style.setProperty('--pos', r.value + '%'); }
    r.addEventListener('input', set);
    set();
  });

  window.SislimFormatTL = formatTL;
})();
